import { render, staticRenderFns } from "./courseChoose.vue?vue&type=template&id=68522336&scoped=true"
import script from "./courseChoose.vue?vue&type=script&lang=js"
export * from "./courseChoose.vue?vue&type=script&lang=js"
import style0 from "./courseChoose.vue?vue&type=style&index=0&id=68522336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68522336",
  null
  
)

export default component.exports